export const getResourceName = (record, fieldsName) => {
  let name = ''
  
  if (fieldsName) {
    const fields = fieldsName.map((field) => record[field])
    name = fields.join(' ')
  }

  return name
}
